<div class="action-group mb-8">
  <ng-template #default>
    <div class="action-list flex-start">
      <thehubz-asset-bulk-edit
        *ngIf="false"
        [bulkEditType]="'collections'"
        [buttonText]="bulkEditButtonText"
        (toggleSelectAllCheckbox)="selectAll.emit($event.checked)"
        (downloadCollection)="downloadClick.emit()"
        (publishCollection)="publishCollection.emit()"
        (shareCollection)="shareCollection.emit()"
        (deleteCollection)="deleteCollection.emit()"
      ></thehubz-asset-bulk-edit>
    </div>
    <div class="action-list justify-end">
      <sp-search-field
        class="action-item"
        [maxWidth]="'400px'"
        (keyUpInput)="searchTextChanged($event)"
        (clearInput)="clearSearch($event)"
        [placeholder]="searchPlaceholder"
        (toggleMobileSearch)="toggleMobileSearch()"
      ></sp-search-field>
      <div class="action-item">
        <button mat-icon-button [matMenuTriggerFor]="gridMenu" *ngIf="!assetViewTypeService.getGridSettings('showListView', gridSettingsKeySuffix)">
          <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
        </button>
        <mat-menu #gridMenu="matMenu">
          <ng-template matMenuContent>
            <sp-table-wheel-setting
              (changeView)="changeView.emit($event)"
              [headerType]="selectedViewType === 'list' ? 'assetList' : 'assetGallery'"
              [menuObjects]="selectedViewType === 'list' ? collectionsTableMenuObject : collectionsGalleryMenuObject"
              [selectedViewType]="assetViewTypeService.getViewType(gridSettingsKeySuffix)"
              [selectedViewSection2]="selectedViewSection2"
              (sortBy)="sortBy.emit($event)"
              [sortByNew]="sortByNew"
              [defaultTableCols]="tableData?.columns"
              [additionalColumns]="tableData?.additionalColumns"
            ></sp-table-wheel-setting>
          </ng-template>
        </mat-menu>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="brandingKey === CustomClients.Vorwerk" [ngIfElse]="default">
    <div class="action-container action-box w-full flex justify-between flex-row place-items-center items-start" [ngClass]="{ '!mb-4': filterBubbles }">
      <div class="left-action-box flex w-full justify-between items-center gap-4">
        <div class="flex flex-wrap justify-start items-center w-full gap-4 mr-2">
          <sp-search-field
            class="max-w-[440px]"
            [maxWidth]="'440px'"
            (keyUpInput)="searchTextChanged($event)"
            (clearInput)="clearSearch($event)"
            [placeholder]="searchPlaceholder"
            (toggleMobileSearch)="toggleMobileSearch()"
          ></sp-search-field>
        </div>
      </div>

      <div class="action-box right-action-box w-full h-auto flex flex-row justify-start md:justify-end xl:justify-end place-items-center gap-4">
        <button mat-icon-button [matMenuTriggerFor]="gridMenu">
          <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
        </button>
        <mat-menu #gridMenu="matMenu">
          <ng-template matMenuContent>
            <sp-table-wheel-setting
              (changeView)="changeView.emit($event)"
              [headerType]="'assetGallery'"
              [headerType]="selectedViewType === 'list' ? 'assetList' : 'assetGallery'"
              [menuObjects]="selectedViewType === 'list' ? collectionsTableMenuObject : collectionsGalleryMenuObject"
              [selectedViewType]="selectedViewType"
              [selectedViewSection2]="selectedViewSection2"
              (sortBy)="sortBy.emit($event)"
              [sortByNew]="sortByNew"
              [defaultTableCols]="tableData?.columns"
              [additionalColumns]="tableData?.additionalColumns"
            ></sp-table-wheel-setting>
          </ng-template>
        </mat-menu>
      </div>
    </div>
  </ng-template>
</div>
<div class="mobile-search" [ngClass]="{ 'is-open': isMobileSearchOpen }" (window:resize)="onEvent($event)" (focusout)="onEvent($event)" tabindex="1">
  <sp-search-field
    [searchText]="searchText"
    [maxWidth]="''"
    (keyUpInput)="searchTextChanged($event)"
    (clearInput)="clearSearch($event)"
    [placeholder]="searchPlaceholder"
    [mobileSearch]="true"
  ></sp-search-field>
</div>
